import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { useMutation } from 'shared/api/hooks';
import { Typography } from '@mui/material';
import { noop } from 'ts-essentials';
export const ResendConfirmButton = memo(function ResendConfirmButton(props) {
    const { onResponse, text } = props;
    const [run, loading_request, response, request_error, isSend] = useMutation('resend_email_confirmation');
    useEffect(() => {
        if (response?.ok) {
            onResponse?.();
        }
    }, [response]);
    return (_jsxs(_Fragment, { children: [_jsx(LoadingButton, { loading: loading_request, onClick: isSend && request_error == null ? noop : run, color: isSend ? 'success' : 'warning', variant: "contained", children: isSend ? 'Подтверждение отправлено' : text ?? 'отправить повторно' }), request_error && (_jsx(Typography, { variant: "subtitle1", color: "error", children: request_error }))] }));
});
